import axiosInstance from '@/utils/api.js'

var state = {
  oneTimeServiceLink: []
}

var getters = {
  ONE_TIME_SERVICE_LINK: (state) => {
    return state.oneTimeServiceLink
  }
}

var mutations = {
  SET_ONE_TIME_SERVICE_LINK: (state, payload) => {
    state.oneTimeServiceLink = payload || []
  }
}

var actions = {
  GET_ONE_TIME_SERVICE_LINK: async (context, payload) => {
    let result = await axiosInstance.get('/users/servicelinks/once?slink_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ONE_TIME_SERVICE_LINK', result.data)
    }
  },
  CREATE_ONE_TIME_SERVICE_LINK: (context, payload) => {
    return axiosInstance.post('/users/servicelinks/once', payload)
  },
  UPDATE_ONE_TIME_SERVICE_LINK: (context, payload) => {
    return axiosInstance.put('/users/servicelinks/once', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/servicesLinkOneTime.js